import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import AddStudentsToClass from "../../Templates/Classes/AddStudentsToClass/AddStudentsToClass";
import { classesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";

function AddStudentsToClassPage() {
  const { contextData } = useContext(userContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [classData, setClassData] = useState(null);

  const { data, loading, error } = useFetch(`${classesURL}/${id}`);

  useEffect(() => {
    if (!loading && !error && data) {
      setClassData(data?.data);
    }
  }, [data, loading, error]);

  return (
    <AddStudentsToClass
      classData={classData}
      loading={loading}
      contextData={contextData}
      url={`${classesURL}/${id}`}
    />
  );
}

export default AddStudentsToClassPage;
